import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HelpConfig } from '@config/help-config';
import { BaseResourceService } from '@core/services/outros/base-resource.service';
import { SchedulePracticalsModel } from '@models/agendamento-pratico/schedule-practicals.model';
import { SchedulePracticalsRequestModel } from '@core/models/agendamento-pratico/schedule-practicals-request.model';

@Injectable({
  providedIn: 'root',
})
export class SchedulePracticalsService extends BaseResourceService<SchedulePracticalsModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.PRACTICAL_SCHEDULING_API}schedulepracticals`, injector);
  }

  createItens(resource: SchedulePracticalsRequestModel[]): Observable<SchedulePracticalsModel[]> {
    return this._httpClient.post<SchedulePracticalsModel[]>(this._url, resource);
  }

  getByOrganization(id: string): Observable<SchedulePracticalsModel> {
    const END_POINT = `${this._url}/organization/${id}`
    return this._httpClient.get<SchedulePracticalsModel>(`${END_POINT}`);
  }

  getByInstructor(id: string): Observable<SchedulePracticalsModel> {
    const END_POINT = `${this._url}/instructor/${id}`
    return this._httpClient.get<SchedulePracticalsModel>(`${END_POINT}`);
  }

  reschedule(id: any, newDate: any): Observable<SchedulePracticalsModel> {
    const END_POINT = `${this._url}/reschedule?id=${id}&newDate=${newDate}`
    return this._httpClient.put<SchedulePracticalsModel>(`${END_POINT}`, null);
  }

  notify(id: any): Observable<SchedulePracticalsModel> {
    const END_POINT = `${this._url}/notify?id=${id}`
    return this._httpClient.put<SchedulePracticalsModel>(`${END_POINT}`, null);
  }

  cancel(id: any): Observable<SchedulePracticalsModel> {
    const END_POINT = `${this._url}/cancel?id=${id}`
    return this._httpClient.put<SchedulePracticalsModel>(`${END_POINT}`, null);
  }

  countSchedule(idStudent: number, category: string){
    const END_POINT = `${this._url}/countSchedules?idStudent=${idStudent}&category=${category}`
    return this._httpClient.get<number>(`${END_POINT}`);
  }
}
